import { Node, ReactNodeViewRenderer } from '@tiptap/react';
import { WhyChooseUsBlockView } from './WhyChooseUsBlockView';

export const WhyChooseUs = Node.create({
    name: 'whychooseus',

    group: 'block',

    defining: true,

    isolating: true,

    parseHTML() {
        return [
            {
                tag: `div[data-type="${this.name}"]`,
            },
        ];
    },

    renderHTML() {
        return [
            'div',
            {
                'data-type': 'whychooseus',
                class: 'whychooseus-block',
            },
            'Why Choose Mal Mart Block'
        ];
    },

    addCommands() {
        return {
            setWhyChooseUs:
                () =>
                    ({ commands }) => {
                        return commands.insertContent({
                            type: this.name,
                        });
                    },
        };
    },

    addNodeView() {
        return ReactNodeViewRenderer(WhyChooseUsBlockView);
    },
});